import Fees from 'client/js/models/fees'
import Locations from 'client/js/models/locations'
class StudentPreferences extends require('common/models/student-preferences') {
   async getFeesPotentialStudentTypes() {
      return await Fees.getPotentialStudentTypes(...arguments)
   }

   async getStudentPreferenceLocations() {
      return await Locations.getLocations()
   }
}

module.exports = StudentPreferences
